import { TMortgagePrograms } from '../../types/suburban';

/* eslint-disable max-lines */
export const DEFAULT_PROGRAMS = {
  house: [
    {
      id: 'base',
      name: 'Базовая',
      description: {
        type: 'paragraph',
        value: 'Cтавка банков без программ государственной поддержки',
      },
      rate: 10.9,
      creditLimitMillions: 60,
      termYears: 30,
    },
    {
      id: 'family',
      name: 'Семейная',
      description: {
        type: 'list',
        value: [
          'Для семей с ребёнком, родившимся после 1 января 2018 года, в том числе, усыновленным.',
          'Для семей с 2 и более несовершеннолетними детьми.',
          'Для семей, воспитывающих детей-инвалидов.',
        ],
      },
      rate: 5.5,
      creditLimitMillions: 12,
      termYears: 30,
    },
    {
      id: 'country',
      name: 'Сельская',
      description: {
        type: 'list',
        value: [
          'Для жителей сельской местности и небольших населённых пунктов — до 30 тыс. человек, кроме городских округов и муниципальных образований Москвы, Московской области и Петербурга.',
          'На момент заключения кредитного договора дом должен быть не старше 3 лет при покупке у юрлица и 5 лет — при покупке у физлица.',
        ],
      },
      rate: 3,
      creditLimitMillions: 5,
      termYears: 25,
      isUntilRate: true,
    },
    {
      id: 'far',
      name: 'Дальневосточная',
      description: {
        type: 'list',
        value: [
          'Для молодых семей, работников медицины и образования, участников программы «Дальневосточный гектар», покупающих жильё на территории ДФО.',
          'Дом должен быть в сельской местности или в любом населённом пункте Магаданской области, Чукотского автономного округа или в одном из моногородов на территории ДФО.',
        ],
      },
      rate: 2,
      creditLimitMillions: 6,
      termYears: 20,
      isUntilRate: true,
    },
  ],
  cottage: [
    {
      id: 'base',
      name: 'Базовая',
      description: {
        type: 'paragraph',
        value: 'Cтавка банков без программ государственной поддержки',
      },
      rate: 10.9,
      creditLimitMillions: 60,
      termYears: 30,
    },
    {
      id: 'preferential',
      name: 'Льготная',
      description: {
        type: 'paragraph',
        value:
          'Максимальная сумма кредита: 12 млн руб. в Москве, МО, Санкт-Петербурге и ЛО; в остальных регионах — 6 млн руб.',
      },
      rate: 7.5,
      creditLimitMillions: 12,
      termYears: 30,
    },
    {
      id: 'family',
      name: 'Семейная',
      description: {
        type: 'list',
        value: [
          'Для семей с ребёнком, родившимся после 1 января 2018 года, в том числе, усыновленным.',
          'Для семей с 2 и более несовершеннолетними детьми.',
          'Для семей, воспитывающих детей-инвалидов.',
        ],
      },
      rate: 5.5,
      creditLimitMillions: 12,
      termYears: 30,
    },
    {
      id: 'it',
      name: 'Льготная для IT-специалистов',
      description: {
        type: 'paragraph',
        value:
          'Для специалистов из компании, работающих в сфере информационных технологий, аккредитованных Минцифры РФ.',
      },
      rate: 5,
      creditLimitMillions: 18,
      termYears: 30,
      isUntilRate: true,
    },
    {
      id: 'country',
      name: 'Сельская',
      description: {
        type: 'list',
        value: [
          'Для жителей сельской местности и небольших населённых пунктов — до 30 тыс. человек, кроме городских округов и муниципальных образований Москвы, Московской области и Петербурга.',
          'На момент заключения кредитного договора дом должен быть не старше 3 лет при покупке у юрлица и 5 лет — при покупке у физлица.',
        ],
      },
      rate: 3,
      creditLimitMillions: 5,
      termYears: 25,
      isUntilRate: true,
    },
    {
      id: 'far',
      name: 'Дальневосточная',
      description: {
        type: 'list',
        value: [
          'Для молодых семей, работников медицины и образования, участников программы «Дальневосточный гектар», покупающих жильё на территории ДФО.',
          'Дом должен быть в сельской местности или в любом населённом пункте Магаданской области, Чукотского автономного округа или в одном из моногородов на территории ДФО.',
        ],
      },
      rate: 2,
      creditLimitMillions: 6,
      termYears: 20,
      isUntilRate: true,
    },
  ],
  land: [
    {
      id: 'base',
      name: 'Базовая',
      description: {
        type: 'paragraph',
        value: 'Cтавка банков без программ государственной поддержки',
      },
      rate: 12.8,
      creditLimitMillions: 60,
      termYears: 30,
    },
    {
      id: 'preferential',
      name: 'Льготная',
      description: {
        type: 'paragraph',
        value: 'Максимальная сумма кредита зависит от региона',
      },
      rate: 7.5,
      creditLimitMillions: 12,
      termYears: 30,
    },
    {
      id: 'family',
      name: 'Семейная',
      description: {
        type: 'list',
        value: [
          'Для семей с ребёнком, родившимся после 1 января 2018 года, в том числе, усыновленным.',
          'Для семей с 2 и более несовершеннолетними детьми.',
          'Для семей, воспитывающих детей-инвалидов.',
        ],
      },
      rate: 5.2,
      creditLimitMillions: 12,
      termYears: 30,
    },
    {
      id: 'it',
      name: 'Льготная для IT-специалистов',
      description: {
        type: 'paragraph',
        value:
          'Для специалистов из компании, работающих в сфере информационных технологий, аккредитованных Минцифры РФ.',
      },
      rate: 5,
      creditLimitMillions: 18,
      termYears: 30,
    },
    {
      id: 'country',
      name: 'Сельская',
      description: {
        type: 'paragraph',
        value:
          'Для жителей небольших населённых пунктов — до 30 тыс. человек, кроме городских округов и муниципальных образований Москвы, Московской области и Петербурга.',
      },
      rate: 3,
      creditLimitMillions: 5,
      termYears: 25,
    },
  ],
  townhouse: [
    {
      id: 'base',
      name: 'Базовая',
      description: {
        type: 'paragraph',
        value: 'Cтавка банков без программ государственной поддержки',
      },
      rate: 10.9,
      creditLimitMillions: 60,
      termYears: 30,
    },
    {
      id: 'preferential',
      name: 'Льготная',
      description: {
        type: 'paragraph',
        value: 'Максимальная сумма кредита зависит от региона',
      },
      rate: 7.5,
      creditLimitMillions: 12,
      termYears: 30,
    },
    {
      id: 'family',
      name: 'Семейная',
      description: {
        type: 'list',
        value: [
          'Для семей с ребёнком, родившимся после 1 января 2018 года, в том числе, усыновленным.',
          'Для семей с 2 и более несовершеннолетними детьми.',
          'Для семей, воспитывающих детей-инвалидов.',
        ],
      },
      rate: 5.5,
      creditLimitMillions: 12,
      termYears: 30,
    },
    {
      id: 'it',
      name: 'Льготная для IT-специалистов',
      description: {
        type: 'paragraph',
        value:
          'Для специалистов из компании, работающих в сфере информационных технологий, аккредитованных Минцифры РФ.',
      },
      rate: 5,
      creditLimitMillions: 18,
      termYears: 30,
    },
    {
      id: 'country',
      name: 'Сельская',
      description: {
        type: 'list',
        value: [
          'Для жителей небольших населённых пунктов — до 30 тыс. человек, кроме городских округов и муниципальных образований Москвы, Московской области и Петербурга.',
          'На момент заключения кредитного договора дом должен быть не старше 3 лет при покупке у юрлица и 5 лет — при покупке у физлица.',
        ],
      },
      rate: 3,
      creditLimitMillions: 5,
      termYears: 25,
    },
    {
      id: 'far',
      name: 'Дальневосточная',
      description: {
        type: 'list',
        value: [
          'Для молодых семей, работников медицины и образования, участников программы «Дальневосточный гектар», покупающих жильё на территории ДФО.',
          'Дом должен быть в сельской местности или в любом населённом пункте Магаданской области, Чукотского автономного округа или в одном из моногородов на территории ДФО.',
        ],
      },
      rate: 2,
      creditLimitMillions: 6,
      termYears: 20,
    },
  ],
  build: [
    {
      id: 'base',
      name: 'Базовая',
      description: {
        type: 'paragraph',
        value: 'Cтавка банков без программ государственной поддержки',
      },
      rate: 6.3,
      creditLimitMillions: 60,
      termYears: 30,
    },
    {
      id: 'preferential',
      name: 'Льготная',
      description: {
        type: 'paragraph',
        value: 'Максимальная сумма кредита зависит от региона',
      },
      rate: 7.5,
      creditLimitMillions: 12,
      termYears: 30,
    },
    {
      id: 'family',
      name: 'Семейная',
      description: {
        type: 'list',
        value: [
          'Для семей с ребёнком, родившимся после 1 января 2018 года, в том числе, усыновленным.',
          'Для семей с 2 и более несовершеннолетними детьми.',
          'Для семей, воспитывающих детей-инвалидов.',
        ],
      },
      rate: 5.5,
      creditLimitMillions: 12,
      termYears: 30,
    },
    {
      id: 'it',
      name: 'Льготная для IT-специалистов',
      description: {
        type: 'paragraph',
        value:
          'Для специалистов из компании, работающих в сфере информационных технологий, аккредитованных Минцифры РФ.',
      },
      rate: 5,
      creditLimitMillions: 18,
      termYears: 30,
    },
    {
      id: 'country',
      name: 'Сельская',
      description: {
        type: 'paragraph',
        value:
          'Для жителей небольших населённых пунктов — до 30 тыс. человек, кроме городских округов и муниципальных образований Москвы, Московской области и Петербурга.',
      },
      rate: 3,
      creditLimitMillions: 5,
      termYears: 25,
    },
    {
      id: 'far',
      name: 'Дальневосточная',
      description: {
        type: 'paragraph',
        value:
          'Для молодых семей, работников медицины и образования, участников программы «Дальневосточный гектар», покупающих жильё на территории ДФО.',
      },
      rate: 2,
      creditLimitMillions: 6,
      termYears: 20,
    },
  ],
} as TMortgagePrograms;
